import { MEASURE } from '../../constants/reading/MeasuresConstants';

const { RAN } = MEASURE;

const getDyslexiaInterpBoundaries = (interpData, measure) =>
    measure === RAN ? { minScore: interpData.min_score } : { maxScore: interpData.max_score };

export default getDyslexiaInterpBoundaries;
